import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconChatActive({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 2.5c-5.39 0-10 3.887-10 8.961 0 2.26.932 4.306 2.435 5.863l-1.666 3.598a1.111 1.111 0 0 0 1.508 1.46l4.71-2.374c.953.27 1.965.415 3.013.415 5.39 0 10-3.888 10-8.962S17.39 2.5 12 2.5" clipRule="evenodd" /></svg></>;
}
export default IconChatActive;